<template>
  <div v-if="component_data" class="section-wrapper" :class="{ is_opened: fridgeIsOpened }">
    
    <div class="preload-bg"></div>

    <div v-if="!fridgeIsOpened" class="closed-container">
      <button @click.prevent="openFridge" class="btn-open">
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 267.59 320.31">
          <path class="cls-1" d="M237.59,186.51A103.8,103.8,0,1,1,133.79,82.72h26"/><polyline class="cls-2" points="148.02 165.44 230.74 82.72 148.02 0"/>
        </svg>
        <span v-html="component_data.params.btn_open_text"></span>
      </button>
    </div>

    <div v-if="fridgeIsOpened" class="opened-container d-none d-lg-block">

      <div v-for="pin in component_data.params.pins" v-bind:key="pin.id" @mouseover="pinMouseOver(pin.id)" @mouseout="pinMouseOut" :class="['pin', pinClassGenerate(pin.id)]">
        <div class="pin__closed"></div>
        <div class="pin__opened">
          <figure v-html="pin.icon">
            
          </figure>
          <span v-html="pin.pin_title"></span>
        </div>
      </div>

      <div class="close-refrigerator">
        <button @click.prevent="closeFridge" class="btn-close">
          <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 267.59 320.31">
            <path class="cls-1" d="M237.59,186.51A103.8,103.8,0,1,1,133.79,82.72h26"/><polyline class="cls-2" points="148.02 165.44 230.74 82.72 148.02 0"/>
          </svg>
          <span v-html="component_data.params.btn_close_text"></span>
        </button>
      </div>

    </div>

    <transition name="slide-fade">
      <div v-if="fridgeIsOpened" class="container-fluid description-box__cnt">
        <div class="row">
          <!--  -->
        </div>
        <div class="row">
          <div class="offset-5 col-7 offset-lg-7 col-lg-4 offset-xl-7 col-xl-3 description-box">
            <h3 v-html="component_data.params.desc_title"></h3>
            <p class="main-paragraph" v-html="component_data.params.desc_main_paragraph"></p>
            <p class="sub-paragraph" v-html="component_data.params.desc_sub_paragraph"></p>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
export default {
  props: ['component_data'],
  data () {
    return {
      fridgeIsOpened: false,
      desc_title: '',
      desc_main_paragraph: '',
      desc_sub_paragraph: ''
    }
  },
  methods: {
    openFridge: function () {
      this.fridgeIsOpened = true
    },
    closeFridge: function () {
      this.fridgeIsOpened = false
    },
    pinMouseOver: function () {
      // this.descIsVisible = true
      // let activePin = this.component_data.params.pins.find(p => {return p.id == id})
      // this.desc_title = activePin.desc_title
      // this.desc_main_paragraph = activePin.desc_main_paragraph
      // this.desc_sub_paragraph = activePin.desc_sub_paragraph
    },
    pinMouseOut: function () {
      // this.descIsVisible = false
    },
    pinClassGenerate: function (id) {
      return 'pin-' + id
    }
  }
}
</script>

<style lang="scss" scoped>
  .section-wrapper {
    width: 100vw;
    height: 46.875vw;
    font-family: 'Lato', sans-serif;
    background: url('../../assets/refrigerator_fs_pins_bg_closed.jpg') no-repeat;
    margin: 80px 0px;
    position: relative;
    background-size: cover;
    background-position: 70% 50%;
    overflow: hidden;
    
    @media only screen and (max-width : 768px) {
      display: none;
    }

    &.is_opened {
      background: url('../../assets/refrigerator_fs_pins_bg_opened.jpg') no-repeat;
      background-size: cover;
      background-position: 70% 50%;
    }

    .pin {
      min-width: 60px;
      height: 60px;
      background: #e41429;
      border-radius: 99px;
      position: absolute;
      cursor: pointer;

      -webkit-box-shadow: 0px 5px 12px -6px rgba(0,0,0,0.35);
      -moz-box-shadow: 0px 5px 12px -6px rgba(0,0,0,0.35);
      box-shadow: 0px 5px 12px -6px rgba(0,0,0,0.35);


      @media only screen and (max-width : 1280px) {
        min-width: 40px;
        height: 40px;
      }

      .pin__closed {

        &:before {
          content: "";
          width: 32px;
          height: 2px;
          background: #fff;
          position: absolute;
          top: 50%;
          left: 50%;

          @media only screen and (max-width : 1280px) {
            width: 24px;
            height: 2px;
          }
        }

        &:after {
          content: "";
          width: 2px;
          height: 32px;
          background: #fff;
          position: absolute;
          top: 50%;
          left: 50%;

          @media only screen and (max-width : 1280px) {
            width: 2px;
            height: 24px;
          }

        }

        &:before, &:after {
          -webkit-transform: translateX(-50%) translateY(-50%); 
          -moz-transform: translateX(-50%) translateY(-50%); 
          -ms-transform: translateX(-50%) translateY(-50%); 
          -o-transform: translateX(-50%)mtranslateY(-50%); 
          transform: translateX(-50%) translateY(-50%);
        }
      }

      .pin__opened {
        display: none;
        font-size: 16px;
        color: #fff;
        padding: 5px 20px 0 10px;
        white-space: nowrap;

        @media only screen and (max-width : 1280px) {
          font-size: 12px;
          padding: 2px 20px 0 10px;
        }

        figure {
          display: inline-block;
          width: 50px;
          height: 50px;
          margin: 0 5px 0 0 !important;

          @media only screen and (max-width : 1280px) {
            width: 37.5px;
            height: 37.5px;
          }
        }

        span {
          display: inline-block;
        }
      }

      &:hover {

        .pin__closed {
          display: none;
        }

        .pin__opened {
          display: block;
        }
      }

      &.pin-1 {
        top: 15.4%;
        left: 46.3%;
        z-index: 10;
      }

      &.pin-2 {
        top: 54.3%;
        left: 44.4%;
        z-index: 8;
      }

      &.pin-3 {
        top: 65%;
        left: 43.2%;
        z-index: 6;
      }

      &.pin-4 {
        top: 75%;
        left: 45.5%;
        z-index: 9;
      }

    }

    .btn-open {
      background: #e41429;
      color: #fff;
      position: absolute;
      top: 46%;
      left: 40%;
      padding: 10px 20px;
      border-radius: 99px;
      cursor: pointer;
      border: none;
      text-align: left;

      &:hover, &:active, &:focus {
        background: darken(#e41429, 5%);
        outline: none;
      }

      svg {
        width: 25px;
        vertical-align: middle;

        .cls-1{
          fill:none;
          stroke:#fff;
          stroke-miterlimit:10;
          stroke-width:60px;
        }
        .cls-2{
          fill:#fff;
        }
      }

      span {
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;
        font-size: 14px;
        line-height: 16px;
      }
    }

    .btn-close {
      background: #e41429;
      color: #fff;
      position: absolute;
      top: 6%;
      left: 41%;
      padding: 10px 20px;
      border-radius: 99px;
      cursor: pointer;
      border: none;
      text-align: left;
      margin-bottom: 80px;

      &:hover, &:active, &:focus {
        background: darken(#e41429, 5%);
        outline: none;
      }

      svg {
        width: 25px;
        vertical-align: middle;

        .cls-1{
          fill:none;
          stroke:#fff;
          stroke-miterlimit:10;
          stroke-width:60px;
        }
        .cls-2{
          fill:#fff;
        }
      }

      span {
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;
        font-size: 14px;
        line-height: 16px;
      }
    }

    .description-box__cnt {
      position: absolute;
      bottom: 0px;
      pointer-events: none;

      .description-box {
        color: #fff;
        padding: 40px 60px 30px 60px;

        -webkit-border-top-left-radius: 60px;
        -moz-border-radius-topleft: 60px;
        border-top-left-radius: 60px;
        
        background: #e41429;
        background: -moz-linear-gradient(left, #e41429 0%, #ae0b11 100%);
        background: -webkit-linear-gradient(left, #e41429 0%,#ae0b11 100%);
        background: linear-gradient(to right, #e41429 0%,#ae0b11 100%);
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e41429', endColorstr='#ae0b11',GradientType=1 );

        @media only screen and (max-width : 1450px) {
          padding: 25px 50px;
        }

        h3 {
          font-size: 38px;
          font-weight: 700;
          margin-bottom: 40px;

          @media only screen and (max-width : 1600px) {
            margin-bottom: 20px;
            font-size: 32px
          }

          @media only screen and (max-width : 1450px) {
            margin-bottom: 20px;
            font-size: 26px;
          }

          @media only screen and (max-width : 1280px) {
            font-size: 26px;
          }

          @media only screen and (max-width : 1199px) {
            font-size: 22px;
          }
        }

        p.main-paragraph {
          font-size: 18px;
          margin-bottom: 30px;
          line-height: 28px;

          @media only screen and (max-width : 1600px) {
            margin-bottom: 20px;
            font-size: 16px;
            line-height: 24px;
          }

          @media only screen and (max-width : 1450px) {
            margin-bottom: 20px;
            font-size: 14px;
            line-height: 20px;
          }

          @media only screen and (max-width : 1280px) {

          }
        }

        p.sub-paragraph {
          font-size: 18px;
          margin-bottom: 0px;
          font-weight: 300;
          line-height: 28px;
          opacity: .9;

          @media only screen and (max-width : 1600px) {
            font-size: 16px;
            line-height: 24px;
          }

          @media only screen and (max-width : 1450px) {
            font-size: 14px;
            line-height: 20px;
          }

          @media only screen and (max-width : 1280px) {

          }
        }
      }
    }

    .preload-bg {
      position: absolute;
      top: -9999px;
      left: -9999px;
      background: url('../../assets/refrigerator_fs_pins_bg_opened.jpg') no-repeat;
    }

    .slide-fade-enter-active {
      transition: all .15s ease;
    }
    .slide-fade-leave-active {
      transition: all .15s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to {
      transform: translateY(100px);
      opacity: 0;
    }
  }
</style>
